import { render, staticRenderFns } from "./footer-submit-buttons.vue?vue&type=template&id=a1759efc"
import script from "./footer-submit-buttons.vue?vue&type=script&lang=js"
export * from "./footer-submit-buttons.vue?vue&type=script&lang=js"
import style0 from "./footer-submit-buttons.vue?vue&type=style&index=0&id=a1759efc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports